import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Slice } from "gatsby";

import GlobalStyles from "~/styles/GlobalStyles";

import CookieNotice from "~/components/CookieNotice";

import { useStickyContext } from "~/context/StickyContext";
import { useLocationContext } from "~/context/LocationContext";

import {
    getElementFromHash,
    scrollToElement,
    isBrowser,
} from "~/utilities/helpers";

const Primary = ({
    children,
    headerNotSticky = false,
    allBlocksAreLoaded = false,
    pageTitle = "",
    pageContext = {},
}) => {
    const { location } = useLocationContext();
    const { hash, state } = location;
    const { totalHeight } = useStickyContext();

    useEffect(() => {
        if (hash && allBlocksAreLoaded) {
            const element = getElementFromHash(hash);

            if (element) {
                scrollToElement(element, totalHeight);
            } else {
                if (isBrowser) {
                    console.log("no element", { element, hash });
                }
            }
        }
    }, [allBlocksAreLoaded, hash, totalHeight, state?.key]);

    return (
        <>
            <GlobalStyles />
            <Slice
                alias="header"
                headerNotSticky={headerNotSticky}
                pageContext={pageContext}
            />
            <main>{children}</main>
            <footer>
                <Slice alias="top-footer" pageTitle={pageTitle} />
                <Slice alias="footer" pageContext={pageContext} />
            </footer>
            <CookieNotice />
        </>
    );
};

Primary.propTypes = {
    children: PropTypes.node.isRequired,
    headerNotSticky: PropTypes.bool,
    allBlocksAreLoaded: PropTypes.bool,
    pageContext: PropTypes.shape({
        urlPermutations: PropTypes.array,
        languageCode: PropTypes.string,
    }),
};

export default Primary;
